<template>
  <q-input outlined :modelValue="modelValue" :label="label" @update:modelValue="$emit('update:modelValue', $event)"
    :error="error">
    <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
    <template v-slot:error>
      <span v-for="err in errors" :key="err">{{ err }}</span>
    </template>
  </q-input>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  modelValue: [String, Number],
  errors: [String, Array],
  label: [String],
});
defineEmits(['update:modelValue']);
const error = computed(() => props.errors && props.errors.length !== 0);
</script>
